export type TelemetryGraphDetail = "summary" | "full";

export type TelemetryGraphNode = {
  id: string;
  label: string;
  value: string | null;
  color: string | null;
  children: TelemetryGraphNode[];
  leaf: boolean;
};

export type TelemetryGraphPayload = {
  schema_version: string;
  room_label: string;
  window: {
    hours?: number;
    room_anchor_timestamp?: string | null;
  };
  detail: TelemetryGraphDetail;
  summary: {
    device_count: number;
    node_count: number;
    leaf_count: number;
    anomaly_count: number;
    series_point_count: number;
    scored_device_count: number;
    room_anchor_timestamp: string | null;
    leader_device_id: string | null;
  };
  roots: TelemetryGraphNode[];
};

export function telemetryGraphPath(windowHours: number, detail: TelemetryGraphDetail) {
  const params = new URLSearchParams({
    window_hours: String(windowHours),
    detail
  });
  return `/api/wellcube/telemetry-graph?${params.toString()}`;
}
